<template>
<div class="body">
  <div class="title">
    整体看板
  </div>
  <div class="block-arr">
    <div class="grid-container">
      <div class="block" :style="{background:item.color,borderColor:item.borderColor}" v-for="(item,index) in blockList">
        <div class="block-title">{{item.name}}</div>
        <div class="block-value" :style="{color:item.borderColor}">{{item.num}}</div>
      </div>
    </div>
  </div>
  <div class="e-chars">
    <div class="e-chars-table" ref="main"></div>
  </div>
</div>
</template>
<script>

import * as echarts from 'echarts'

export default {
  data () {
    return {
      // 块状数据
      blockList: [
        { name: '领取数量', color: 'rgb(245 251 254)', borderColor: 'rgb(64 158 255)', num: 0 },
        { name: '使用数量', color: 'rgb(245 251 254)', borderColor: 'rgb(64 158 255)', num: 0 },
        { name: '使用率', color: 'rgb(245 251 254)', borderColor: 'rgb(64 158 255)', num: 0.00 },
        { name: '券支付总金额', color: 'rgb(241 251 245)', borderColor: 'rgb(94 199 119)', num: 0.00 },
        { name: '券支付订单数', color: 'rgb(241 251 245)', borderColor: 'rgb(94 199 119)', num: 0 },
        { name: '券笔单价', color: 'rgb(255 248 242)', borderColor: 'rgb(248 182 108)', num: 0.00 },
        { name: '券客单价', color: 'rgb(241 251 245)', borderColor: 'rgb(94 199 119)', num: 0.00 },
        { name: '券优惠金额', color: 'rgb(241 251 245)', borderColor: 'rgb(94 199 119)', num: 0.00 }]
    }
  },
  props: {
    map: {},
    data: {}
  },
  watch: {
    data: {
      handler (val) {
        this.initBlock(val)
      },
      deep: true
    },
    map: {
      handler (val) {
        this.initEchars(val)
      },
      deep: true
    }
  },
  mounted () {
    this.initEchars(this.map)
    this.initBlock(this.data)
  },
  methods: {
    // 块状初始化
    initBlock (data) {
      this.blockList[0].num = data.receiveCount
      this.blockList[1].num = data.useCount
      this.blockList[2].num = data.usageRate + '%'
      this.blockList[3].num = (data.sumAmount).toFixed(2)
      this.blockList[4].num = data.orderCount
      // 券笔单价 券支付总金额/使用数量
      this.blockList[5].num = (data.sumCouponAmount / data.useCount).toFixed(2)
      if (data.useCount === 0) {
        this.blockList[5].num = 0.00.toFixed(2)
      }
      this.blockList[6].num = (data.sumAmount / data.orderCount).toFixed(2)
      if (data.orderCount === 0) {
        this.blockList[6].num = 0.00.toFixed(2)
      }
      this.blockList[7].num = (data.sumCouponAmount).toFixed(2)
    },
    // 图表初始化
    initEchars (map) {
      var option = {
        title: {
          text: '数量',
          fontWeight: 'normal'

        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['领取数量', '使用数量', '券支付金额']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: map.dateArr
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '领取数量',
            type: 'line',
            stack: 'Total',
            data: map.receiveCounts,
            label: {
              color: 'orange',
              show: true, // 显示标签
              position: 'right' // 标签的位置，可以是 'top', 'bottom', 'left', 'right', 'inside', 'insideTop', 'insideBottom', 'insideLeft', 'insideRight', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight'
            }
          },
          {
            name: '使用数量',
            type: 'line',
            stack: 'Total',
            data: map.useCounts,
            label: {
              color: 'green',
              show: true, // 显示标签
              position: 'left' // 标签的位置，可以是 'top', 'bottom', 'left', 'right', 'inside', 'insideTop', 'insideBottom', 'insideLeft', 'insideRight', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight'
            }
          },
          {
            name: '券支付金额',
            type: 'line',
            stack: 'Total',
            data: map.couponAmounts,
            label: {
              color: 'red',
              show: true, // 显示标签
              position: 'top' // 标签的位置，可以是 'top', 'bottom', 'left', 'right', 'inside', 'insideTop', 'insideBottom', 'insideLeft', 'insideRight', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight'
            }
          }
        ]
      }
      var chartDom = this.$refs.main
      var myChart = echarts.init(chartDom)
      option && myChart.setOption(option)
    }
  }
}

</script>
<style scoped>
    .title{
      font-weight: bold;
    }
    .grid-container {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 40px;
    }
    .block{
      width: 350px;
      height: 130px;
      border: 1px solid;

    }
    .block-title{
      margin: 5% 5%;
    }
    .block-arr{
      margin-top: 3%;
    }
    .block-value{
      margin-left: 5%;
      margin-top: -3%;
    }
    .e-chars-table{
      width: 1000px;
      height: 600px;
    }
    .e-chars{
      margin:5%;
    }
</style>
